import React, { useState, useContext, useEffect } from "react";
import "../cod/styles/auth.css";
import { Link } from "react-router-dom";
import AuthContext from "../context/auth/authContext";
import Spinner from "../utilities/Spinner";

const Register = props => {
  const authContext = useContext(AuthContext);
  const { register, error, loading, admin } = authContext;

  useEffect(() => {
    if (admin) {
      props.history.push(`/dashboard`);
    }
    // eslint-disable-next-line
  }, [error, admin]);

  const [user, setUser] = useState({
    name: "",
    email: "",
    position: "",
    password: "",
    password2: "",
    code: ""
  });

  const { name, email, position, password, password2, code } = user;

  const onChange = e => {
    setUser({ ...user, [e.target.name]: e.target.value });
  };

  const onSubmit = e => {
    e.preventDefault();
    if (name === "" || email === "" || code === "" || password === "") {
      alert("All fields must be entered");
    } else if (password !== password2) {
      alert("Passwords do not match");
    } else if (email.indexOf(" ") >= 0) {
      alert("Email can not contain spaces");
    } else {
      register({
        name,
        email,
        position,
        password,
        code
      });
    }
  };

  return (
    <div className="blubackCont">
      {loading ? <Spinner /> : null}
      <div className="loginShape4"></div>
      <div className="loginShape2"></div>
      <div className="loginShape6"></div>
      <div className="loginShape9"></div>
      <div className="authCont">
        <div className="authMiniCont">
          <h1 className="h1CreateAccount">Create an Account</h1>
          <form onSubmit={onSubmit}>
            <div className="form-group fg1">
              <label htmlFor="name">Name</label>
              <input
                required
                type="text"
                name="name"
                value={name}
                onChange={onChange}
              />
            </div>
            <div className="form-group">
              <label htmlFor="email">Email address</label>
              <input
                required
                type="email"
                name="email"
                value={email}
                onChange={onChange}
              />
            </div>
            <div className="form-group">
              <label htmlFor="name">Position</label>
              <input
                type="text"
                name="position"
                value={position}
                onChange={onChange}
              />
            </div>
            <div className="form-group"></div>
            <div className="form-group">
              <label htmlFor="password">Password</label>
              <input
                required
                type="password"
                name="password"
                value={password}
                onChange={onChange}
                minLength="6"
              />
            </div>
            <div className="form-group fg4">
              <label htmlFor="password2">Confirm password</label>
              <input
                required
                type="password"
                name="password2"
                value={password2}
                onChange={onChange}
                minLength="6"
              />
            </div>
            <div className="form-group">
              <label htmlFor="code">Company code</label>
              <input
                required
                type="text"
                name="code"
                value={code}
                onChange={onChange}
              />
            </div>
            <input
              type="submit"
              value="Register"
              className="fg5 registerFormBTN"
            />
          </form>
        </div>
      </div>
      <div className="bottomTextP">
        <p>
          Already have an account? Sign in{" "}
          <Link className="hereTextP" to={"/"}>
            here.
          </Link>
        </p>
      </div>
    </div>
  );
};

export default Register;
